import {connect} from 'react-redux';
import React from 'react';
import { withRouter } from 'react-router-dom'
import { toast } from 'react-toastify';

import Input from 'muicss/lib/react/input';
import {UserModel} from '/app/src/model';
import style from './style.css';


import {isMobile, checkMobileOS} from '/app/src/lib/detectMobile'

import {Flex, SVGButton} from '/app/src/component/'

export class Login extends React.Component {
    constructor(props) {
        super(props);
        this._handleLoginClick = this._handleLoginClick.bind(this);
        this._handleInput = this._handleInput.bind(this);
        this._handleKeyPress = this._handleKeyPress.bind(this);
        // this._validateInput = this._validateInput.bind(this);
        this._handleForgottenClick = this._handleForgottenClick.bind(this);
        this._handleVerificationClick = this._handleVerificationClick.bind(this);
        this._handleResetVerificationMail = this._handleResetVerificationMail.bind(this);
        this._handleBackClick = this._handleBackClick.bind(this);
        this._renderLogin = this._renderLogin.bind(this);
        this._renderForgotten = this._renderForgotten.bind(this);
        this._renderVerifyEmail = this._renderVerifyEmail.bind(this);
        this._handleResetClick = this._handleResetClick.bind(this);
        this.failLogin = this.failLogin.bind(this);
        this._renderScreen = this._renderScreen.bind(this);
        this._renderMobile = this._renderMobile.bind(this);

        var initScreen = 'login'
        if (isMobile()) {
            initScreen = 'mobile'
        }

        this.state = {
            email: '',
            password: '',
            resetEmail: '',
            showForgottenInput: '',
            forgotPassword: false,
            verifyEmail: false,
            recoveryEmailExists: true,
            loginError: '',
            recoveryEmail: '',
            screen: initScreen
        }
    }

    failLogin(res) {
        if(res.body && res.body.error && res.body.error.message && res.body.error.message.indexOf('verified') > -1){
            this.setState({loginError: 'Användare har inte verifierat sitt konto'})
        }else{
            this.setState({loginError: 'Användarnamnet och/eller lösenordet stämmer inte'})
        }
    }

    _handleResetClick() {
        const recoveryEmail = this.state.recoveryEmail;
        UserModel.resetPassword(recoveryEmail)
            .end((err, res) => {
                if (res.status === 200) {
                    toast('Ett mail har skickats till angivet email')
                }
                if (res.status === 404) {
                    this.setState({recoveryEmailExists: false});
                }
            });
    }

    _handleResetVerificationMail() {
        const recoveryEmail = this.state.recoveryEmail;
        UserModel.resetVerificationMail(recoveryEmail)
            .end((err, res) => {
                if (res.status === 200) {
                    toast('Ett mail har skickats till angivet email')
                }
                if (res.status === 404) {
                    this.setState({recoveryEmailExists: false});
                }
            });
    }


    _handleForgottenClick() {
        this.setState((prevState) => ({screen: 'forgotten'}));
    }

    _handleVerificationClick(){
        this.setState((prevState) => ({screen: 'verifyEmail'}))
    }

    _handleBackClick(){
        this.setState((prevState) => ({screen: 'login'}))
    }

    _renderLogin() {
        return <Flex column grow center height='100%'>
            <a href="https://jibber.se/">
                <Flex column hAlignContent='center'>
                    <img className={style.LoginImage} displayname='LoginImage' src='/images/computing.png' alt='login'/>
                    <img className={style.LoginLogo} displayname='LoginLogo' src='/images/jibber-blue-logo.png' alt='login logo'/>
                </Flex>
            </a>
            <Flex color='darkgrey' className={style.InputLabel}>E-post</Flex>
            <Input className={style.Input} name='email' value={this.state.email} onKeyPress={this._handleKeyPress} onChange={this._handleInput}/>
            <Flex color='darkgrey' className={style.InputLabel}>Lösenord</Flex>
            <Input className={style.Input} name='password' value={this.state.password} onKeyPress={this._handleKeyPress} onChange={this._handleInput} type='password'/>
            {this.state.loginError.length > 0 && <p className={style.errorMsg}> {this.state.loginError} </p>}
            <SVGButton className={style.LoginButton} onClick={this._handleLoginClick} text='Logga in'/>
            <span className={style.ForgotPassword} displayname='ForgottenClick' onClick={this._handleForgottenClick}>
                Glömt lösenord?
            </span>
            <span className={style.ForgotPassword} displayname='VerificationClick' onClick={this._handleVerificationClick}>
            Verifiera E-post
            </span>
        </Flex>
    }

    _renderForgotten() {
        return <Flex column center displayName={'ForgottenSection'} color='black' h='80%'>
            <Flex fontSize='45px'> Återställa lösenord </Flex>
            <Flex fontSize='16px' marginTop='10px' marginBottom='40px'> Det är lugnt! Skriv in e-posten som kontot är registrerad under så skickar vi ett nytt lösenord. </Flex>
            <Flex color='darkgrey' className={style.InputLabel}>E-post</Flex>
            <Input className={style.Input}
                name='recoveryEmail'
                value={this.state.recoveryEmail}
                onKeyPress={this._handleKeyPress}
                onChange={this._handleInput}/>
            <p className={style.errorMsg}> {!this.state.recoveryEmailExists && 'Angivet email finns inte i systemet.' } </p>
            <SVGButton className={style.LoginButton} onClick={this._handleResetClick} text='Återställ lösenord'/>
            <SVGButton className={style.LoginButton} onClick={this._handleBackClick} text='Tillbaka till login' marginTop='200px'/>
        </Flex>

    }

    _renderVerifyEmail() {
        return <Flex column center displayName={'VerifyEmailSection'} color='black' h='80%'>
            <Flex fontSize='45px'> Verifiera E-post</Flex>
            <Flex fontSize='16px' marginTop='10px' marginBottom='40px'> Skriv in e-posten som du vill skicka verifikation till så skickar vi ett nytt email. </Flex>
            <Flex color='darkgrey' className={style.InputLabel}>E-post</Flex>
            <Input className={style.Input}
                name='recoveryEmail'
                value={this.state.recoveryEmail}
                onKeyPress={this._handleKeyPress}
                onChange={this._handleInput}/>
            <p className={style.errorMsg}> {!this.state.recoveryEmailExists && 'Angivet email finns inte i systemet.' } </p>
            <SVGButton className={style.LoginButton} onClick={this._handleResetVerificationMail} text='Verifiera E-post'/>
            <SVGButton className={style.LoginButton} onClick={this._handleBackClick} text='Tillbaka till login' marginTop='200px'/>
        </Flex>
    }

    _handleLoginClick(){
        this.props.dispatch(UserModel.login(this.state.email, this.state.password, this.failLogin))
    }

    _handleInput(e){
        this.setState({[e.target.name]: e.target.value})
    }

    _handleKeyPress(e){
        if(e.key === 'Enter'){
            if (!this.state.forgotPassword)
                this._handleLoginClick();
        }
    }

    _renderMobile() {
        const mobileDevice = checkMobileOS()
        var innerDOM;
        switch(mobileDevice) {
            case "android":
                innerDOM = <Flex center column>
                    <h2> Ladda ner vår app </h2>
                    <a href='https://play.google.com/store/apps/details?id=com.jibber.jibberchat&hl=sv'>
                        <img className={style.StoreIcon} src='/images/mobil-google-play.png' alt=''/>
                    </a>
                </Flex>
                break;
            case 'apple':
                innerDOM = <Flex center column>
                    <h2> Ladda ner vår app </h2>
                    <a href='https://itunes.apple.com/se/app/jibber/id1370412344?mt=8'>
                        <img className={style.StoreIcon} src='/images/mobil-app-store.png' alt=''/>
                    </a>
                </Flex>
                break;
            case 'notSupported':
                innerDOM = <p> {'Den här enheten stöds tyvärr inte av Jibber.'} </p>
                break;
            default:
                innerDOM = <Flex center column>
                <h2> Ladda ner vår app </h2>
                <a href='https://play.google.com/store/apps/details?id=com.jibber.jibberchat&hl=sv'>
                    <img className={style.StoreIcon} src='/images/mobil-google-play.png' alt=''/>
                </a>
                <a href='https://itunes.apple.com/se/app/jibber/id1370412344?mt=8'>
                    <img className={style.StoreIcon} src='/images/mobil-app-store.png' alt=''/>
                </a>
                </Flex>
        }
        return <Flex column center height='100%'>
            <img className={style.MobileImage} src='/images/jibber-chat-mobile-img.png' alt=''/>
            <Flex> {innerDOM} </Flex>
            <Flex column>
                <a className={style.LinkText} href='https://jibber.se'>
                    {'Tillbaka till jibber.se'}
                </a>
                <a className={style.LinkText} href='https://jibber.se/skapa-konto'>
                    {'Skapa ett Jibber konto'}
                </a>
            </Flex>
        </Flex>

    }

    _renderScreen(){
        switch (this.state.screen) {
            case 'forgotten':
                return this._renderForgotten();
            case 'verifyEmail':
                return this._renderVerifyEmail();
            case 'mobile':
                return this._renderMobile();
            default:
                return this._renderLogin();
        }
    }

    render(){
        return (
            <Flex column grow h='80%'>
                <Flex hAlignContent="right">
                        <SVGButton style={this.state.screen === 'mobile' ? {display: 'none'} : {}} className={style.LoginRegister} text='Skapa konto'
                            onClick={()=>{window.location.href = 'https://jibber.se/skapa-konto'}}
                            color='green'
                            border height='45px'
                            w='200px'
                        />
                </Flex>
                {this._renderScreen()}
            </Flex>
        )
    }
}


Login.propTypes = {

};

export default withRouter(connect()(Login));



// WEBPACK FOOTER //
// ./src/layout/Login/index.js